import React, { useEffect, useState } from 'react';
import ReactDOM from "react-dom/client";
import { Box } from '@mui/material';
import { DataGrid } from 'devextreme-react/data-grid';
import { ISubAnalysis } from '../../../../../../../interfaces/Pricelist/ISubAnalysis';
import { PricelistApis } from '../../../../../../../hooks/apis/PricelistApis';
import { IAnalysisAnalyteDetail } from '../../../../../../../interfaces/Pricelist/IAnalysisAnalyteDetail';

const SubAnalysisDetails = (detailData: ISubAnalysis) => {
  const { getSubAnalysisAnalyteInfo } = PricelistApis();
  const [error, setError] = useState('');
  const [subAnalysisAnalyteInfo, setSubAnalysisAnalyteInfo] = useState<IAnalysisAnalyteDetail[] | undefined>();

  useEffect(() => {
    getSubAnalysisAnalyteInfo(detailData.Analysis, detailData.Matrix, detailData.Description, detailData.IsGroupAnalysis)
      .then((data) => {
        if (data?.message) {
          setError(data?.message);
        } else {
          setSubAnalysisAnalyteInfo(data);
        }
      })
      .catch((e) => setError(e.toString()));
  }, [detailData, getSubAnalysisAnalyteInfo]);

  return (
    <Box className="subAnalysisAnalyteInfo">
      {error && !(subAnalysisAnalyteInfo?.length > 0) ? <Box className="errorBox">{error}</Box> : null}
      {!error && !(subAnalysisAnalyteInfo?.length > 0) ? <Box className="loadingBox">Loading Sub Analysis Info</Box> : null}
      {subAnalysisAnalyteInfo?.length > 0 ?
        <DataGrid
        className="subAnalysisDetailGrid"
        dataSource={subAnalysisAnalyteInfo}
        rowAlternationEnabled={true}
        showBorders={false}
        wordWrapEnabled={true}
        hoverStateEnabled={false}
        sorting={{ mode: "multiple" }}
        paging={{ enabled: false }}
        headerFilter={{ visible: false }}
        columns={[
          { dataField: "AnalyteOrder", visible: false, sortOrder: "asc", dataType: "number" },
          { dataField: "Analyte", dataType: "string" },
          { dataField: "AnalyteAliases", caption: "Also known as", dataType: "string" },
          {
            allowFiltering: false,
            width: 250,
            dataField: "Comments",
            dataType: "string",
            cellTemplate: (container, options) => {
              const root = ReactDOM.createRoot(container);
              root.render(<Box className="analysisComments">{options?.data?.Comments}</Box>);
            },
          },
          { dataField: "PqlText", caption: detailData.Units, width: 150, alignment: "center", dataType: "string" },
          { dataField: "NataPerth", dataType: "boolean", visible: detailData.PerthTesting, width: 110 },
          { dataField: "NataSydney", dataType: "boolean", visible: detailData.SydneyTesting, width: 110 },
          { dataField: "NataMelbourne", dataType: "boolean", visible: detailData.MelbourneTesting, width: 130 },
          { dataField: "NataSubcon", dataType: "boolean", visible: detailData.SubconTesting, width: 130 },
        ]}
      /> : null }
    </Box>
  );
};

export default SubAnalysisDetails;
